import LoadAdobeScript from "@tm/insurance/analytics/loadAdobeScript";
import {
  MMTHeaderProps,
  MMTInsuranceHeader,
} from "../static/components/MMTInsuranceHeader";

interface MMTInsuranceHeaderPropsWithWrapper extends MMTHeaderProps {
  Wrapper?: (props: { children: JSX.Element[] }) => JSX.Element;
  showNav?: boolean;
}

export function withMMTInsuranceHeader(
  component: JSX.Element,
  headerOptions: MMTInsuranceHeaderPropsWithWrapper = {},
  mobileTitle = "",
  myOrders = false,
  goToMyOrders = () => void 0,
  displayWhiteHeader = false,
  isMyBiz = false,
  exitWebViewOnBack = false,
  showPwaHeaderBackButton = true,
  showPwaHeader = true
) {
  const { Wrapper, ...headerProps } = headerOptions;

  const authComponent = (
    <MMTInsuranceHeader
      headerProps={headerProps}
      mobileTitle={mobileTitle}
      myOrders={myOrders}
      goToMyOrders={goToMyOrders}
      displayWhiteHeader={displayWhiteHeader}
      isMyBiz={isMyBiz}
      exitWebViewOnBack={exitWebViewOnBack}
      showPwaHeaderBackButton={showPwaHeaderBackButton}
      showPwaHeader={showPwaHeader}
    />
  );

  if (headerProps?.forceLogin) {
    return authComponent;
  }

  if (Wrapper) {
    return (
      <Wrapper>
        <LoadAdobeScript />
        {authComponent}
        {component}
      </Wrapper>
    );
  }
  return (
    <>
      <LoadAdobeScript />
      {authComponent}
      {component}
    </>
  );
}
